<script type="ts">
	import { createEventDispatcher } from 'svelte';
	import type { Robot } from '$lib/patterns/strategy/examples/types';
	import { getRobot } from '$lib/patterns/strategy/examples/examples';

	import Avatar from '$Chat/Avatar.svelte';

	export let show: string;
	export let group: string;

	const activeList = show.split(',').map((robot) => robot.trim());

	let Robots: Robot.Chatbot[] = [];

	$: initializeRobots(group);

	function initializeRobots(name: string) {
		if (!name) {
			return false;
		}
		Robots = activeList.map((name) => getRobot(group, name) as unknown as Robot.Chatbot);
	}

	const dispatch = createEventDispatcher();

	async function robotMessage(robot: Robot.Chatbot) {
		const message = await robot.getMessage();
		const chatMessage: Robot.AchordMessage = {
			...message,
			author: {
				name: robot.name,
				avatar: robot.avatar
			}
		};
		dispatch('destroy');
		dispatch('insert', chatMessage);
	}
</script>

<div class="robots">
	<div class="label">Available Robots</div>
	<div class="bots">
		{#each Robots as robot}
			<div class="bot" on:click={() => robotMessage(robot)}>
				<Avatar size="32px" name={robot.avatar} />
				<div class="meta">
					<div class="name">{robot.name}</div>
					<div class="description">
						{robot.description}
					</div>
				</div>
			</div>
		{/each}
	</div>
</div>

<style lang="scss">
	.robots {
		padding: 18px;
	}
	.label {
		text-transform: uppercase;
		font-size: 0.875em;
		padding-left: 11px;
		font-weight: 600;
		color: var(--demo-text-low);
	}
	.bots {
		border-radius: $border_radius;
		background-color: var(--demo-bg-40);
		border: 1px solid var(--demo-bg-60);

		display: flex;
		flex-direction: column;
	}

	.bot {
		display: flex;
		align-items: center;
		gap: 10px;

		border-radius: $border_radius;
		cursor: pointer;

		padding: 11px;

		&:hover {
			background-color: var(--demo-bg-41);
		}

		&:first-child {
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		}
		&:last-child {
			border-top-left-radius: 0;
			border-top-right-radius: 0;
		}
	}

	.name {
		font-weight: 500;
		color: var(--demo-text);
		line-height: 1;
	}

	.description {
		font-size: 0.875em;
		color: var(--demo-text-low);
		font-weight: 400;
		line-height: 1.4;
	}
</style>
